import { gql } from "@apollo/client";

export const GET_GESTION_PACIENTES_ASISTENCIAL = gql`
  query getAllGestionPacientesAsistencial(
    $idDelegacion: Int!
    $idEstado: Int!
    $fechaDesde: CustomDateTime
    $fechaHasta: CustomDateTime
    $where: PacienteAsistencialModelFilterInput
  ) {
    allGestionPacientesAsistencial(
      idDelegacion: $idDelegacion
      idEstado: $idEstado
      fechaDesde: $fechaDesde
      fechaHasta: $fechaHasta
      where: $where
    ) {
      idEvaluacion
      codigo
      razonSocial
      cod_SAP
      codigoSAPCliente
      idEstadoPaciente
      cantconx
      fechaDesde
      fechaHasta
      idPaciente
      paciente
      sexo
      edad
      idPlanCuidado
      plan
      nombrePlan
      programa
    }
  }
`;